import React from "react";
import './button.scss';
import LinkedInIcon from '../../assets/icons/LinkedIn.svg';

const LinkedInButton = () => {
  return <div onClick={()=>window.open("https://www.linkedin.com/in/ravin-perera/")} 
  className="icon-button"><img src={LinkedInIcon} alt="LinkedIn Button" style={{ width: "24px", marginRight: "8px" }} /><h5>LinkedIn</h5></div>;
};

export default LinkedInButton